<script>
    import REST from '../RESTClass.js';
    import { watchResize } from "svelte-watch-resize";
    import { setMoverVisibility } from '../Utils';

    import Card from '../Components/Card/Card.svelte';
    import Mover from '../Components/Mover/Mover.svelte';

    let calendarData;
    let moverVisible = true;

    const API = new REST();
    API.getCalendar()
        .then(data => calendarData = data);

</script>

<section class="calendar">
    <h2 class="padded">Najbliższe wydarzenia</h2>
    <div use:watchResize={node => moverVisible = setMoverVisibility(node)} class="events padded">
        {#if calendarData}
            {#each calendarData as entry}
                <Card 
                    type="calendar"
                    content={{
                        date: entry.date,
                        description: entry.description,
                        hours: entry.hours,
                        thumbnail: entry.thumbnail,
                        title: entry.title
                    }}
                    props={{
                        spaced: true
                    }}
                />
            {/each}
        {/if}
    </div>
    <Mover 
        props={{
            range: 200,
            visible: moverVisible
        }}
    />
</section>

<style type="text/scss">
    h2 {
        color: #c2ae8d;
        font-family: 'Rufina', serif;
        font-size: 18px;
        margin: 1.2rem 0;
        text-transform: uppercase;
    }

    .events {
        display: flex;
        overflow-x: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
</style>